module.exports = __webpack_public_path__ + "img/pro_four_1.52f78e83.jpg";